import api from "../api";
import {iniciarRequisicao} from './../../helpers/index';

class TempoCoberturaPorPopularidade {
  async getListaFull(headers) {
    const response = await api.get("/drp/tempo-cobertura-por-curvas", { headers });
    return response;
  }

  async deleteMultiplos(headers, params) {
    const response = await api({
      method: 'delete',
      url: `/drp_delete_multiplos_tempo_cobertura_popularidade`,
      headers,
      data: params
    });
    return response;
  }

  async store(headers, params) {
    const response = await api({
      method: 'post',
      url: '/drp/tempo-cobertura-por-curvas',
      headers,
      data: params
    });
    return response;
  }

  async aplicarTempoCobertura(params) {
    const headers = iniciarRequisicao();

    const response = await api({
      method: 'post',
      url: '/drp/tempo-cobertura-por-curvas/aplica-em-produtos',
      headers,
      data: params
    });
    return response;
  }
}

export default new TempoCoberturaPorPopularidade();
